/**
 * Renders `mobileText` below `md` and `text` from `md` up, for designs whose
 * phone and desktop frames use different wording. The hidden copy is
 * `display: none`, so assistive tech only reads the visible one.
 */
export function ResponsiveText({ text, mobileText }: { text: string; mobileText?: string }) {
  if (!mobileText || mobileText === text) return text;
  return (
    <>
      <span className="md:hidden">{mobileText}</span>
      <span className="hidden md:inline">{text}</span>
    </>
  );
}
